<!-- 示例页面 -->
<template>
  <div class="page staffGrantDetail">
    <div class="p16 flex-row">
      <div>
        <span class="cur" @click="back"><i class="el-icon-arrow-left"></i>返回</span>
        <el-divider direction="vertical"  class="color999"></el-divider>
        <span class="color999 cur" @click="back">收支账&nbsp;/&nbsp;</span>
      </div>
      <div>店员应发明细</div>
    </div>
    <div class="page-head">
      <div class="mains-content">
        <div class="member-content-box br10">
          <div class="pltr16">
            <el-date-picker v-model="dataMonth" type="month" value-format="yyyy-MM" placeholder="选择月" @change="getDetails" :clearable="false"></el-date-picker>
          </div>
          <div class="plr16">
            <p class="tables-title"><span class="staffGrantDetail-img"><img src="../../../assets/images/new/shopManager.png" alt=""></span> 店长投资分红</p>
            <el-table :data="form.shopManagerFeeList" :max-height="height - 265" border="" header-cell-class-name="table_header_bgcolor">
              <el-table-column prop="shopName" label="门店名称"></el-table-column>
              <el-table-column prop="achievementEncourageAmount" label="店长利润分红" width="auto" align="center" :key="Math.random()">
                <template slot="header">
                  <div style="line-height: 1.5;">店长利润分红 <br/>{{form.shopManagerFeeList.length > 0 ? form.shopManagerFeeList[0].achievementEncourageRate: 0}}%</div>
                </template>
              </el-table-column>
              <el-table-column prop="socialSubsidyAmount" label="社保补贴" width="auto"></el-table-column>
              <el-table-column prop="contractShareAmount" width="auto" label="店长投资分红" align="center" :key="Math.random()">
                <template slot="header">
                  <div style="line-height: 1.5;">店长投资分红 <br/>{{form.shopManagerFeeList.length > 0 ? form.shopManagerFeeList[0].contractShareRate : 0}}%</div>
                </template>
              </el-table-column>
              <el-table-column prop="shopManangerKpiAmount" label="店长实发绩效" width="auto"></el-table-column>
              <el-table-column prop="receiptMealAmount" width="auto" label="达标加餐"></el-table-column>
              <el-table-column prop="personalSecSocAmount" width="auto" label="社保个人部分"></el-table-column>
              <el-table-column prop="totalAmount" width="auto" label="合计金额"></el-table-column>
            </el-table>
          </div>
          <div class="plr16">
            <p class="tables-title"><span class="staffGrantDetail-img"><img src="../../../assets/images/new/prepShopManager.png" alt=""></span> 预备店长投资分红</p>
            <el-table :data="form.prepShopManagerFeeList" :max-height="height - 265" border header-cell-class-name="table_header_bgcolor">
              <el-table-column prop="shopName" label="门店名称"></el-table-column>
              <el-table-column prop="achievementEncourageAmount" label="预备店长利润分红" width="auto" align="center" :key="Math.random()">
                <template slot="header">
                  <div style="line-height: 1.5;">预备店长利润分红 <br/>{{form.prepShopManagerFeeList.length > 0 ? form.prepShopManagerFeeList[0].achievementEncourageRate : 0}}%</div>
                </template>
              </el-table-column>
              <el-table-column prop="socialSubsidyAmount" label="社保补贴" width="auto"></el-table-column>
              <el-table-column prop="contractShareAmount" width="auto" label="预备店长投资分红" align="center" :key="Math.random()">
                <template slot="header">
                  <div style="line-height: 1.5;">预备店长投资分红 <br/>{{form.prepShopManagerFeeList.length > 0 ? form.prepShopManagerFeeList[0].contractShareRate : 0}}%</div>
                </template>
              </el-table-column>
              <el-table-column prop="receiptMealAmount" width="auto" label="达标加餐"></el-table-column>
              <el-table-column prop="personalSecSocAmount" width="auto" label="社保个人部分"></el-table-column>
              <el-table-column prop="totalAmount" width="auto" label="合计金额"></el-table-column>
            </el-table>
          </div>

          <div class="plr16">
            <p class="tables-title"><span class="staffGrantDetail-img"><img src="../../../assets/images/new/prepShopManager.png" alt=""></span> 代管店长利润分红</p>
            <el-table :data="form.shopStaffManagerFeeList" :max-height="height - 265" border header-cell-class-name="table_header_bgcolor">
              <el-table-column prop="shopName" label="门店名称" width="auto"></el-table-column>
              <el-table-column prop="achievementEncourageAmount" label="代管店长利润分红" width="auto" align="center" :key="Math.random()">
                <template slot="header">
                  <div style="line-height: 1.5;">代管店长利润分红 <br/>{{form.shopStaffManagerFeeList.length > 0 ? form.shopStaffManagerFeeList[0].achievementEncourageRate : 0}}%</div>
                </template>
              </el-table-column>
              <el-table-column prop="socialSubsidyAmount" label="社保补贴" width="auto"></el-table-column>
              <el-table-column prop="personalSecSocAmount" width="auto" label="社保个人部分"></el-table-column>
              <el-table-column prop="totalAmount" width="auto" label="合计金额"></el-table-column>
            </el-table>
          </div>


          <div class="plr16">
            <p class="tables-title"><span class="staffGrantDetail-img"><img src="../../../assets/images/new/staffManager.png" alt=""></span> 店员投资分红</p>
            <el-table :data="form.staffFeeList" :max-height="height - 265" border header-cell-class-name="table_header_bgcolor">
              <el-table-column prop="shopName" label="门店名称"></el-table-column>
              <el-table-column prop="achievementEncourageAmount" label="店员利润分红" width="auto" align="center" :key="Math.random()">
                <template slot="header">
                  <div style="line-height: 1.5;">店员利润分红 <br/>{{form.staffFeeList.length > 0 ? form.staffFeeList[0].achievementEncourageRate : 0}}%</div>
                </template>
              </el-table-column>
              <el-table-column prop="contractShareAmount" width="auto" label="店员投资分红" align="center" :key="Math.random()">
                <template slot="header">
                  <div style="line-height: 1.5;">店员投资分红 <br/>{{form.staffFeeList.length > 0 ? form.staffFeeList[0].contractShareRate : 0}}%</div>
                </template>
              </el-table-column>
              <el-table-column prop="totalAmount" width="auto" label="合计金额"></el-table-column>
            </el-table>
          </div>
          <div class="plrb16">
            <p class="tables-title"><span class="staffGrantDetail-img"><img src="../../../assets/images/new/introduce.png" alt=""></span> 介绍费</p>
            <el-table :data="form.introductionFeeList" :max-height="height - 265" border header-cell-class-name="table_header_bgcolor">
              <el-table-column prop="shopName" label="门店名称"></el-table-column>
              <el-table-column prop="introduceTypeCn" label="介绍类型"></el-table-column>
              <el-table-column prop="staffName" label="被介绍人姓名" width="auto"></el-table-column>
              <el-table-column prop="actualAmount" label="金额" width="auto"></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
export default {
  data() {
    return {
      dataMonth: '',
      form: {
        shopManagerFeeList: [],
        prepShopManagerFeeList: [],
        staffFeeList: [],
        shopStaffManagerFeeList: []
      },
      height: this.$store.getters.MainHeight,
      list: []
    };
  },
  mixins: [minxin],
  components: {},
  computed: {},

  created() {
    // this.dataMonth = this.formatMonth(new Date())
    this.dataMonth = this.getLastMonth(new Date())
    this.getDetails();
  },

  methods: {
    back() {
      this.$router.push("/dataList/shopBill");
    },
    getDetails () {
      this.$api.get(this.$url.shopStaffFee.get, {reportMonth: this.dataMonth, type: 'staff'}).then(res => {
        if (res) {
          this.form = res;
        }
      });
    },
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.page-head {
  height: 100%;
}
.staffGrantDetail {
  .staffGrantDetail-img {
    display: inline-block;
    width: 20px;
    height: 20px;
    img {
      width: 100%;
      height: 100%;
      vertical-align: middle;
    }
  }
}
.mains-content {
  height: calc(100vh - 125px);
  overflow: auto;
  .tables-title {
    font-weight: bold;
    padding: 20px 0;
  }
  .member-content-box {
    background: #fff;
  }
  .member-header {
    padding: 16px;
    display: flex;
  }
}
</style>